module.exports = __webpack_public_path__ + "img/logo.27480b94.svg";